// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot, hydrateRoot } from 'react-dom-client';
import www_util from 'hola_pub_util';
class Error_boundary extends React.PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      has_error: false
    });
  }
  static getDerivedStateFromError(error) {
    return {
      has_error: true
    };
  }
  componentDidCatch(error, info) {
    this.setState({
      has_error: true
    });
    if (this.props.log) this.props.log(error, info);
  }
  render() {
    if (this.state.has_error) return this.props.error_ui || null;
    return this.props.children;
  }
}
export var dom_render = (comp, root, log = www_util.perr_react, new_api) => {
  if (typeof root == 'string') root = document.querySelector(root);
  if (new_api) {
    var react_root = createRoot(root);
    react_root.render(/*#__PURE__*/React.createElement(Error_boundary, {
      log: log
    }, comp));
  } else {
    ReactDOM.render(/*#__PURE__*/React.createElement(Error_boundary, {
      log: log
    }, comp), root);
  }
};
export var dom_hydrate = (comp, root, log = www_util.perr_react, new_api) => {
  if (typeof root == 'string') root = document.querySelector(root);
  if (new_api) hydrateRoot(root, /*#__PURE__*/React.createElement(Error_boundary, {
    log: log
  }, comp));else {
    ReactDOM.hydrate(/*#__PURE__*/React.createElement(Error_boundary, {
      log: log
    }, comp), root);
  }
};